module.exports = __webpack_public_path__ + "static/media/Logo-Ministerio-Economia.6b6e9b93.png";